import { render, staticRenderFns } from "./SupplierCategoryModal.vue?vue&type=template&id=5489b1dc&scoped=true"
import script from "./SupplierCategoryModal.vue?vue&type=script&lang=js"
export * from "./SupplierCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierCategoryModal.vue?vue&type=style&index=0&id=5489b1dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489b1dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5489b1dc')) {
      api.createRecord('5489b1dc', component.options)
    } else {
      api.reload('5489b1dc', component.options)
    }
    module.hot.accept("./SupplierCategoryModal.vue?vue&type=template&id=5489b1dc&scoped=true", function () {
      api.rerender('5489b1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supplier/components/SupplierCategoryModal.vue"
export default component.exports